import {Component, Input, OnInit} from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-waitlist-block',
  templateUrl: './waitlist-block.component.html',
  styleUrls: ['./waitlist-block.component.scss'],
})
export class WaitlistBlockComponent implements OnInit {
  @Input() waitlist_item
  constructor(
      public dataService: DataService
  ) { }

  ngOnInit() {}

}
